module.exports = __webpack_public_path__ + "static/img/checked.da188cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/checked.png
// module id = ETZa
// module chunks = 1